/**
 * Created by chenjia on 2016/10/9.
 */
let Config = require('../../Config/Config');

let isLogin = {
    isLogin: function(data, success, error) {
        $.ajax({
            url: Config.serviceInterface.isLogin,
            method: 'get',
            dataType: 'json',
            success: function (data) {
                if (data) {
                    if ($.isFunction(success)) {
                        success(data);
                    }
                } else {
                    if ($.isFunction(error)) {
                        error();
                    }
                }
            }
        });
    }
};

module.exports = isLogin;


// WEBPACK FOOTER //
// ./src/js/model/isLoginModel/isLoginModel.js